import React, { useState, useEffect, useRef } from 'react';
import Newsletters from 'services/Newsletters/';
import { Link } from 'react-router-dom';
import InputEmail from 'components/InputEmail';
import Group from 'images/icons/news-check.svg';
import TagManagerService from 'services/TagManager';
import { cleanSearch } from 'utils/index';
import { newsLetterTxt } from 'config/translate/variables';
import Rut from 'components/Forms/Inputs/InputRut';
import style from './style.scss';//NOSONAR

const Newsletter = () => {

    const [open, setOpen] = useState(false);
    const [active, setActive] = useState(false);
    const [formIsValid, setFormIsValid] = useState(false);
    const [rutIsValid, setRutIsValid] = useState(false);
    const [emailIsValid, setEmailValid] = useState(false);
    const [rutValue, setRutValue] = useState('');

    const emailInput = useRef(null);
    const checkbox = useRef(null);
    let timer = null;

    const openForm = () => {

        setOpen(!open);

        TagManagerService.homeBody('Suscribir', window.location.href);
    }

    const closeForm = () => {
        setOpen(!open);
    }

    useEffect(()=>{
        setTimeout(()=> validateForm() , 100);
    },[emailIsValid, rutIsValid])

    const submitSuscribe = () => {
        let email = emailInput.current.value;
        let rut = cleanSearch(rutValue.replace( /\s/g, ''));

        Newsletters.suscribeNewsletter(email, rut).then(response => {
            clearSubmit();
            return response
        });

        setActive(!active);

        TagManagerService.suscribe('Envío solicitud', email);
    }

    const clearSubmit = () => {

        setRutValue('');
        setRutIsValid(false);
        emailInput.current.value = '';
        checkbox.current.checked = false;

    }

    const validateForm = () => {
        const isvalid =  rutIsValid && emailIsValid && checkbox.current.checked;
        if (isvalid !== formIsValid) {
            setFormIsValid(isvalid);
        }
    }

    const _getValidMail = (isValid) => {
        setEmailValid(isValid);
    }

    useEffect(() => {
        if (active) {
            timer = setTimeout(() => {
                setActive(false);
                setOpen(false);
            }, 3000);
        }
        return () => {
            clearTimeout(timer);
        }
    });

    const rutValid = (valid, value) => {
        setRutIsValid(valid);
        setRutValue(value);
    }

    return (
        <section className={'footer-newsletter'+(open ? ' open' : '')}>
            <div className={'footer-newsletter-form' + ((open && !active) ? ' open' : '')} >
                <button className="footer-newsletter-container-form-icon" onClick={closeForm} aria-label="Newsletter close"><i className="font-icn go-back footer-newsletter-form-icon"></i></button>
                <div className="footer-newsletter-container-form">
                    <div className={'footer-newsletter-container-form-mail'}>
                        <InputEmail
                            ref={emailInput}
                            showIcon={true}
                            key="Email"
                            className={'footer-newsletter-form-mail'}
                            name="Email"
                            placeholder="Mail"
                            value={''}
                            type="email"
                            helpText=""
                            size=""
                            message={{ error: "Mail inválido" }}
                            validateForm={validateForm}
                            aria-label="Mail input"
                            callbackValidate={_getValidMail}
                        />
                    </div>
                    <div className={'footer-newsletter-container-form-rut' + ((!rutIsValid) ? ' container-error' : '')}>
                        <label htmlFor="rut">RUT</label>
                        <Rut callbackisValid={rutValid} errorMessageValue={'Rut inválido'}/>
                    </div>
                </div>
                <div className="footer-newsletter-container-form-label">
                    <label className="footer-newsletter-form-label">
                        <input className="footer-newsletter-input-check mobile-click" type="checkbox" name='Terms Acceptation' ref={checkbox} onChange={validateForm} />
                        <span>Acepto <Link to="/institucional/terminos-condiciones" className="footer-newsletter-link">términos y condiciones</Link></span>
                    </label>
                    <div className="footer-newsletter-form-container-buttons">
                        <button className='footer-newsletter-form-button-back' onClick={closeForm} aria-label='Close form'><i className="font-icn go-back footer-newsletter-form-icon"></i> Volver</button>
                        <button type="submit" className={'footer-newsletter-form-submit' + (formIsValid ? ' active' : '')} onClick={submitSuscribe} aria-label="Submit form">Enviar</button>
                    </div>
                </div>
            </div>
            <div className={'footer-newsletter-suscribe'+(active ? ' suscribed' : '')}>
                <span className="footer-newsletter-text" onClick={openForm} >{newsLetterTxt.title}<i className='font-icn point-arrow-right'></i></span>
                <button className="footer-newsletter-submit" onClick={openForm} aria-label='Open Form'>
                    <span className="footer-newsletter-submit-text">{newsLetterTxt.btnSubmit}</span>
                </button>
            </div>
            <div className={'footer-newsletter-container-subscribed' + (active ? ' active' : '')} >
                <span className="footer-newsletter-container-subscribed-icon" dangerouslySetInnerHTML={{ __html: Group }}></span>
                <span className="footer-newsletter-container-subscribed-title">{newsLetterTxt.successTitle}</span>
                <span className="footer-newsletter-container-subscribed-paragraph">{newsLetterTxt.successSubtitle}</span>
            </div>
        </section>
    )
}

export default Newsletter;
